var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-row',[_c('v-col',[_c('title-component',{attrs:{"keyword":_vm.keyword}}),_c('CommonTable',{attrs:{"keyword":_vm.keyword}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }